import { Component } from '@angular/core';

@Component({
    templateUrl: 'ftest.html'
})

export class Test  {

}